module.exports = __webpack_public_path__ + "static/img/iphone-x-mockup-acagouvieux.a549e14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iphone-x-mockup-acagouvieux.png
// module id = 6qEG
// module chunks = 1